import React, { /* useState, useEffect, useContext */ } from "react";
import { /* UserContext, Axios */ } from './UserContext';

export default function Admin(){

    // --- Użytkownik i wylogowanie ---

    //const {user} = useContext(UserContext);

    //const {logout} = useContext(UserContext);

    return (
        <div id="app-outer-container">

        </div>
    );
};